// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"styles_dropdownContainer__W2Gd0","defaultTriggerClassName":"styles_defaultTriggerClassName__RTNZM"};